/* Capital RC theme – global scripts */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var routes = (window.theme && window.theme.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictiveSearch: '/search/suggest' };

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return withCommas;
    });
  }

  function toast(message) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.hidden = true; }, 3000);
  }

  /* ---------------- Overlay + drawers ---------------- */
  var overlay;
  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'drawer-overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeAllDrawers);
    }
    return overlay;
  }
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    getOverlay().classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('button, a, input, select');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeAllDrawers() {
    $$('.menu-drawer.is-open, .cart-drawer.is-open, .filters.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllDrawers(); closeLightbox(); }
  });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-open-drawer')));
      return;
    }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeAllDrawers(); }
  });

  /* ---------------- Announcement countdown ---------------- */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.init) return; el.dataset.init = '1';
      var cutoffHour = parseFloat(el.getAttribute('data-cutoff-hour') || '14');
      var days = (el.getAttribute('data-days') || '1,2,3,4,5').split(',').map(Number);
      var tz = el.getAttribute('data-timezone') || 'Pacific/Auckland';
      var out = $('[data-countdown-time]', el);
      var labelToday = el.getAttribute('data-label-today');
      var labelNext = el.getAttribute('data-label-next');
      var label = $('[data-countdown-label]', el);

      function nzNow() {
        var parts = new Intl.DateTimeFormat('en-NZ', { timeZone: tz, hour12: false, weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).formatToParts(new Date());
        var o = {};
        parts.forEach(function (p) { o[p.type] = p.value; });
        var dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        return { day: dayMap[o.weekday], h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10), s: parseInt(o.second, 10) };
      }
      function tick() {
        var n = nzNow();
        var nowSecs = n.h * 3600 + n.m * 60 + n.s;
        var cutoffSecs = Math.round(cutoffHour * 3600);
        if (days.indexOf(n.day) !== -1 && nowSecs < cutoffSecs) {
          var diff = cutoffSecs - nowSecs;
          var hh = Math.floor(diff / 3600), mm = Math.floor((diff % 3600) / 60), ss = diff % 60;
          if (out) out.textContent = (hh > 0 ? hh + 'h ' : '') + (mm < 10 && hh > 0 ? '0' : '') + mm + 'm ' + (ss < 10 ? '0' : '') + ss + 's';
          if (label && labelToday) label.textContent = labelToday;
          if (out) out.hidden = false;
        } else {
          if (out) out.hidden = true;
          if (label && labelNext) label.textContent = labelNext;
        }
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------------- Predictive search ---------------- */
  function initPredictiveSearch() {
    $$('[data-predictive-search]').forEach(function (wrap) {
      if (wrap.dataset.init) return; wrap.dataset.init = '1';
      var input = $('input[type="search"]', wrap);
      var results = $('[data-predictive-results]', wrap);
      if (!input || !results) return;
      var timer, controller;

      function close() { results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
      function render(data, q) {
        var r = data.resources.results;
        var html = '';
        if (r.products && r.products.length) {
          html += '<div class="predictive__group-title">Products</div>';
          r.products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="48" height="48">' : '';
            html += '<a class="predictive__item" href="' + p.url + '" role="option"><span class="predictive__thumb">' + img + '</span><span><span class="predictive__title">' + escapeHtml(p.title) + '</span><br><span class="predictive__price">' + (p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '') + '</span></span></a>';
          });
        }
        if (r.collections && r.collections.length) {
          html += '<div class="predictive__group-title">Categories &amp; brands</div>';
          r.collections.forEach(function (c) { html += '<a class="predictive__item" href="' + c.url + '" role="option"><span class="predictive__title">' + escapeHtml(c.title) + '</span></a>'; });
        }
        if (!html) html = '<div class="predictive__empty">No matches for “' + escapeHtml(q) + '”. Try a part number or kit name.</div>';
        html += '<a class="predictive__all" href="' + routes.search + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last">See all results for “' + escapeHtml(q) + '” →</a>';
        results.innerHTML = html;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () {
          if (controller) controller.abort();
          controller = window.AbortController ? new AbortController() : null;
          fetch(routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][prefix]=last&resources[options][unavailable_products]=last', controller ? { signal: controller.signal } : {})
            .then(function (res) { return res.json(); })
            .then(function (data) { render(data, q); })
            .catch(function () {});
        }, 200);
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowDown') { var first = $('.predictive__item', results); if (first) { e.preventDefault(); first.focus(); } }
      });
      results.addEventListener('keydown', function (e) {
        var items = $$('.predictive__item, .predictive__all', results);
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && i < items.length - 1) { e.preventDefault(); items[i + 1].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? items[i - 1] : input).focus(); }
        if (e.key === 'Escape') { close(); input.focus(); }
      });
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------- Mega menu keyboard / touch ---------------- */
  function initMegaMenu() {
    $$('.main-nav__item[data-has-mega] > .main-nav__link').forEach(function (link) {
      var item = link.parentElement;
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { item.classList.remove('is-open'); link.focus(); }
      });
      link.addEventListener('touchend', function (e) {
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          $$('.main-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
          item.classList.add('is-open');
        }
      });
    });
    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.main-nav')) $$('.main-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }, { passive: true });
  }

  /* ---------------- Cart ---------------- */
  var cartType = document.body.getAttribute('data-cart-type') || 'drawer';

  function refreshCart(openAfter) {
    return fetch(routes.root + '?sections=cart-drawer,cart-count')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawer = $('#CartDrawer');
        if (drawer && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var fresh = tmp.querySelector('#CartDrawer');
          if (fresh) {
            var wasOpen = drawer.classList.contains('is-open');
            drawer.innerHTML = fresh.innerHTML;
            if (wasOpen) drawer.classList.add('is-open');
          }
        }
        if (sections['cart-count']) {
          var t2 = document.createElement('div');
          t2.innerHTML = sections['cart-count'];
          var countEl = t2.querySelector('[data-cart-count]');
          if (countEl) {
            var count = countEl.getAttribute('data-count');
            $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
          }
        }
        if (openAfter) openDrawer($('#CartDrawer'));
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || cartType === 'page') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var fd = new FormData(form);
    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.json.description || res.json.message || 'Could not add to cart'); return; }
        return refreshCart(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  });

  function changeLine(key, qty, ctx) {
    var line = ctx && ctx.closest('.cart-item');
    if (line) line.style.opacity = '.5';
    return fetch(routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.status && cart.description) toast(cart.description);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCart(false);
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-cart-remove'), 0, rm); return; }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty');
      var input = wrap && $('input', wrap);
      if (!input) return;
      e.preventDefault();
      var min = parseInt(input.min || '0', 10);
      var val = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = val;
      if (input.hasAttribute('data-line-key')) changeLine(input.getAttribute('data-line-key'), val, input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-line-key]');
    if (input && e.isTrusted) {
      clearTimeout(input._t);
      input._t = setTimeout(function () { changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0, input); }, 400);
    }
  });

  /* ---------------- Hero slider ---------------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      if (hero.dataset.init) return; hero.dataset.init = '1';
      var track = $('.hero__slides', hero);
      var slides = $$('.hero__slide', hero);
      var dots = $$('.hero__dot', hero);
      if (!track || slides.length < 2) return;
      var i = 0, timer;
      var delay = parseInt(hero.getAttribute('data-autoplay') || '0', 10) * 1000;
      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); $$('a, button', s).forEach(function (a) { a.tabIndex = k === i ? 0 : -1; }); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function start() { if (delay) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); } }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
      var prev = $('[data-hero-prev]', hero), next = $('[data-hero-next]', hero);
      if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
      if (next) next.addEventListener('click', function () { go(i + 1); start(); });
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
      hero.addEventListener('mouseleave', start);
      var sx = null;
      track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; clearInterval(timer); }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
        sx = null; start();
      });
      go(0); start();
    });
  }

  /* ---------------- Product rails ---------------- */
  function initRails() {
    $$('[data-rail]').forEach(function (wrap) {
      if (wrap.dataset.init) return; wrap.dataset.init = '1';
      var rail = $('.rail', wrap);
      var prev = $('.rail-btn--prev', wrap), next = $('.rail-btn--next', wrap);
      if (!rail) return;
      function update() {
        if (prev) prev.disabled = rail.scrollLeft <= 4;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      }
      function step(dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------- Part finder ---------------- */
  function initPartFinder() {
    $$('[data-part-finder]').forEach(function (finder) {
      if (finder.dataset.init) return; finder.dataset.init = '1';
      var dataEl = $('script[type="application/json"]', finder);
      if (!dataEl) return;
      var raw;
      try { raw = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var items = raw.items || [];
      var nested = items.some(function (it) { return it.kits && it.kits.length; });
      var data = [];
      if (nested) {
        data = items;
      } else {
        // Flat list of "Brand Kit" links – group by the first word
        var groups = {};
        items.forEach(function (it) {
          var words = it.title.split(/\s+/);
          var brand = words[0];
          var kitName = words.length > 1 ? words.slice(1).join(' ') : it.title;
          var key = brand.toLowerCase();
          if (!groups[key]) { groups[key] = { title: brand, url: it.url, kits: [] }; data.push(groups[key]); }
          groups[key].kits.push({ title: kitName, url: it.url });
        });
        data.sort(function (a, b) { return a.title.localeCompare(b.title); });
      }
      var brandSel = $('[data-finder-brand]', finder);
      var kitSel = $('[data-finder-kit]', finder);
      var form = $('form', finder);
      if (brandSel) {
        brandSel.innerHTML = '';
        data.forEach(function (b) {
          var o = document.createElement('option');
          o.textContent = b.title;
          brandSel.appendChild(o);
        });
      }
      function fillKits() {
        var brand = data[brandSel ? brandSel.selectedIndex : 0];
        if (!kitSel || !brand) return;
        kitSel.innerHTML = '';
        if (brand.kits.length === 0) {
          var o = document.createElement('option');
          o.value = brand.url; o.textContent = 'All ' + brand.title + ' parts';
          kitSel.appendChild(o);
          return;
        }
        brand.kits.forEach(function (k) {
          var opt = document.createElement('option');
          opt.value = k.url; opt.textContent = k.title;
          kitSel.appendChild(opt);
        });
      }
      if (brandSel) brandSel.addEventListener('change', fillKits);
      fillKits();
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var url = kitSel ? kitSel.value : null;
        if (url) window.location.href = url;
      });
    });
  }

  /* ---------------- Product page ---------------- */
  function initProduct() {
    $$('[data-product]').forEach(function (root) {
      var jsonEl = $('[data-product-json]', root);
      var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      var form = $('form[data-product-form]', root);
      var idInput = form && $('input[name="id"]', form);
      var priceEl = $('[data-product-price]', root);
      var stockEl = $('[data-product-stock]', root);
      var skuEl = $('[data-product-sku]', root);
      var btn = form && $('[type="submit"]', form);
      var lowStock = parseInt(root.getAttribute('data-low-stock') || '3', 10);

      // Gallery
      var slides = $('.gallery__slides', root);
      var thumbs = $$('.gallery__thumb', root);
      function showMedia(id) {
        if (!slides) return;
        var target = $('[data-media-id="' + id + '"]', slides);
        if (target) slides.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-target') === String(id) ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-target')); }); });
      if (slides) {
        slides.addEventListener('scroll', function () {
          clearTimeout(slides._t);
          slides._t = setTimeout(function () {
            var idx = Math.round(slides.scrollLeft / slides.clientWidth);
            var slide = slides.children[idx];
            if (slide) thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-target') === slide.getAttribute('data-media-id') ? 'true' : 'false'); });
          }, 80);
        }, { passive: true });
        slides.addEventListener('click', function (e) {
          var img = e.target.closest('img[data-zoom]');
          if (img) openLightbox(img.getAttribute('data-zoom'), img.alt);
        });
      }

      if (!product || !form) return;

      function currentOptions() {
        return product.options.map(function (name, i) {
          var checked = $('input[name="option' + (i + 1) + '"]:checked', root);
          var sel = $('select[name="option' + (i + 1) + '"]', root);
          return checked ? checked.value : (sel ? sel.value : null);
        });
      }
      function update() {
        var opts = currentOptions();
        var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
        // label availability on pills
        product.options.forEach(function (name, i) {
          $$('input[name="option' + (i + 1) + '"]', root).forEach(function (inp) {
            var test = opts.slice(); test[i] = inp.value;
            var exists = product.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === test[k]; }); });
            inp.closest('.option-pill').classList.toggle('is-unavailable', !exists);
          });
          var legendVal = $('[data-option-value="' + (i + 1) + '"]', root);
          if (legendVal) legendVal.textContent = opts[i] || '';
        });
        if (!variant) {
          if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
          return;
        }
        idInput.value = variant.id;
        if (priceEl) {
          var html = '<span class="price__now">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) html += '<s class="price__was">' + formatMoney(variant.compare_at_price) + '</s><span class="badge badge--sale">Save ' + formatMoney(variant.compare_at_price - variant.price) + '</span>';
          priceEl.innerHTML = html;
          priceEl.classList.toggle('price--sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
        }
        if (skuEl) skuEl.textContent = variant.sku ? 'SKU: ' + variant.sku : '';
        var inv = (product.inventory || {})[variant.id];
        if (stockEl) {
          if (!variant.available) { stockEl.className = 'stock stock--out'; stockEl.textContent = 'Sold out'; }
          else if (inv && inv.managed && inv.qty > 0 && inv.qty < 5) { stockEl.className = 'stock stock--low'; stockEl.textContent = 'Low stock'; }
          else if (inv && inv.managed && inv.qty > 0) { stockEl.className = 'stock stock--in'; stockEl.textContent = 'In stock'; }
          else if (inv && inv.managed && inv.qty <= 0) { stockEl.className = 'stock stock--low'; stockEl.textContent = 'Available on backorder'; }
          else { stockEl.className = 'stock stock--in'; stockEl.textContent = 'In stock'; }
        }
        if (btn) { btn.disabled = !variant.available; btn.textContent = variant.available ? (btn.getAttribute('data-label') || 'Add to cart') : 'Sold out'; }
        $$('[data-sticky-price]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
        if (variant.featured_media) showMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('input[name^="option"], select[name^="option"]', root).forEach(function (el) { el.addEventListener('change', update); });
      if (product.variants.length > 1) update();

      // Sticky add to cart on mobile
      var sticky = $('[data-sticky-atc]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }).observe(btn);
        var stickyBtn = $('button', sticky);
        if (stickyBtn) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); });
      }
    });
  }

  /* ---------------- Lightbox ---------------- */
  var lb;
  function openLightbox(src, alt) {
    closeLightbox();
    lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Image zoom');
    lb.innerHTML = '<button class="lightbox__close" type="button" aria-label="Close zoom"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button><img alt="">';
    lb.querySelector('img').src = src;
    lb.querySelector('img').alt = alt || '';
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.lightbox__close')) closeLightbox(); });
    document.body.appendChild(lb);
    document.body.style.overflow = 'hidden';
    lb.querySelector('button').focus();
  }
  function closeLightbox() { if (lb) { lb.remove(); lb = null; document.body.style.overflow = ''; } }

  /* ---------------- Collection filters ---------------- */
  function initFilters() {
    $$('form[data-filter-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) {
          if (window.matchMedia('(min-width: 990px)').matches || e.target.matches('select')) submitFilters(form);
        }
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(form); });
    });
    $$('select[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }
  function submitFilters(form) {
    var params = new URLSearchParams(new FormData(form));
    $$('input[type="number"]', form).forEach(function (n) { if (!n.value) params.delete(n.name); });
    var current = new URL(window.location.href);
    var sort = current.searchParams.get('sort_by');
    if (sort) params.set('sort_by', sort);
    var q = current.searchParams.get('q');
    if (q && !params.has('q')) params.set('q', q);
    window.location.href = current.pathname + '?' + params.toString();
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    document.body.setAttribute('data-cart-type', document.body.getAttribute('data-cart-type') || cartType);
    initCountdown();
    initPredictiveSearch();
    initMegaMenu();
    initHero();
    initRails();
    initPartFinder();
    initProduct();
    initFilters();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function () { initHero(); initRails(); initPartFinder(); initCountdown(); initPredictiveSearch(); });
})();
